import React, { useRef, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { addPharmacyConfigApi } from "../../../services/pharmacyConfigs.services";
import { nameRules } from "../common/validators";

const SaltFormModal = ({ open, setOpen, onCreated }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const closeAndReset = () => {
    form.resetFields();
    setOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    addPharmacyConfigApi("salts", values)
      .then((res) => {
        message.success("Drug name added successfully");
        setLoading(false);
        closeAndReset();
        onCreated?.(res.data);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || "Failed to save drug name");
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Add Drug Name"
      open={open}
      onCancel={closeAndReset}
      centered
      width={420}
      destroyOnClose
      okText="Save"
      confirmLoading={loading}
      onOk={() => formRef.current?.submit()}
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={nameRules("Drug", { maxLength: null })}
        >
          <Input placeholder="Drug Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SaltFormModal;
